import type { ReactNode } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

interface TopBarFirmwareModeProps {
    /**
     * Callback to change the map mode.
     */
    changeMode: (name: string) => void;
}

/**
 * Top bar displayed when the map is in firmware view mode.
 *
 * @param {TopBarFirmwareModeProps} props - The component props.
 * @returns {ReactNode} The rendered firmware mode top bar.
 */
const TopBarFirmwareMode = ({
    changeMode,
}: TopBarFirmwareModeProps): ReactNode => (
    <div className="topBar">
        <div className="row">
            <div className="col-sm">
                <p className="textTopbar">Firmware View</p>
            </div>
            <div className="col-sm">
                <div className="link" onClick={() => changeMode("view")}>
                    Exit Firmware
                </div>
            </div>
        </div>
    </div>
);

const mapStateToProps = () => ({});
const mapDispatchToProps = {
    changeMode: actions.map.general.changeMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopBarFirmwareMode);
